import { useEffect, useState } from "react";
import RadioInput from "../../../components/common/ui/Inputs/RadioInput";
import { useDispatch, useSelector } from "react-redux";
import { DateInput, TextInput } from "../../../components/common/ui/Inputs";
import { eventsActions } from "../../../_store/events.slice";
import { useLocation } from "react-router-dom";
import Table from "../../../components/common/table/Table";
import Button from "../../../components/common/ui/Button";
import { showToastNotification } from "../../../components/common/ui/NotificationModal/ToastNotication";
import editIcon from "../../../assets/svg/edit-icon.svg";
import deleteIcon from "../../../assets/svg/delete-icon.svg";
import CustomLoader from "../../../components/common/ui/Loader";
import { Popup } from "../../../components/common/ui/NotificationModal/Popup";
import ToggleSwitch from "../../../components/common/ui/Inputs/ToggleSwitch";
import { history } from "../../../_helpers";
import Swal from "sweetalert2";
import CollapsibleTable from "../../../components/common/table/CollapsiveTable";

function PublicEvents() {
  const dispatch = useDispatch();

  const {
    getPublicSingleEventListResponse,
    getPublicRecurrenceEventListResponse,
    loading,
  } = useSelector((x) => x?.events);

  const { ActiveStatus } = useSelector((x) => x?.dropDown);

  const [isPending, setIsPending] = useState(false);
  const [editRow, setEditRow] = useState({});

  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`
  );
  const [recurrenceApiParams, setRecurrenceApiParams] = useState(
    `?page=${1}&limit=${10}`
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  const [recurrencePageNo, setRecurrencePageNo] = useState(1);
  const [recurrencerowCountPerPage, setRecurrenceRowCountPerPage] =
    useState(10);

  const [Filter, setFilter] = useState({
    title: "",
    startDateTime: "",
    endDateTime: "",
    status: true,
  });
  const [expandedRows, setExpandedRows] = useState({});

  const totalCount = getPublicSingleEventListResponse?.data?.totalItems || 0;
  const recurrenceTotalCount =
    getPublicRecurrenceEventListResponse?.data?.totalItems || 0;

  useEffect(() => {
    const resetHandler = () => {};

    window.addEventListener("resetCalendarPage", resetHandler);
    return () => {
      window.removeEventListener("resetCalendarPage", resetHandler);
    };
  }, []);

  const columns = [
    {
      name: "Title",
      key: "memberId",
      selector: (row) => row.title,
      sortable: true,
    },
    {
      name: "Start",
      key: "start",
      // selector: (row) => {
      //   const formatted = new Date(row.start).toLocaleString("en-IN", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   });
      //   return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      // },
      selector: (row) => {
        const formatted = new Date(row.start).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },

      sortable: true,
    },
    {
      name: "End",
      key: "end",
      // selector: (row) => {
      //   return new Date(row.end).toLocaleString("en-IN", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   });
      // },
      // selector: (row) => {
      //   const formatted = new Date(row.end).toLocaleString("en-IN", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   });
      //   return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      // },
      selector: (row) => {
        const formatted = new Date(row.end).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },
      sortable: true,
    },

    {
      name: "Created by",
      key: "phoneNumber",
      selector: (row) =>
        row.createdBy ? row.createdBy?.firstName + " " + row.createdBy?.lastName :"-",
      sortable: true,
    },
    {
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              editEvent(row);
            }}
          />
          <img
            src={deleteIcon}
            title="Delete"
            alt="delete-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleSingleEventDelete(row);
            }}
          />
          <ToggleSwitch
            name={`Status${row.memberId}`}
            id={`Status${row.memberId}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleSingleEventStatusUpdate(e, row)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const recurrenceTableColumn = [
    {
      name: "Title",
      key: "memberId",
      selector: (row) => row.title,
      cell: (row) => <div>{row.title}</div>,
      sortable: true,
    },

    {
      name: "Created by",
      key: "phoneNumber",
      selector: (row) =>
       row.createdBy ? row.createdBy?.firstName + " " + row.createdBy?.lastName: "-" ,
      sortable: false,
    },
    {
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={deleteIcon}
            title="Delete"
            alt="delete-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleRecurrenceEventDelete(row);
            }}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  const ChildrenColumn = [
    {
      name: "S.No",
      key: "memberId",
      selector: (row, i) => i + 1,
      sortable: false,
    },
    {
      name: "Title",
      key: "memberId",
      selector: (row) => row.title,
      sortable: false,
    },
    {
      name: "Start",
      key: "firstName",
      // selector: (row) => {
      //   return new Date(row.start).toLocaleString("en-IN", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   });
      // },
      // selector: (row) => {
      //   const formatted = new Date(row.start).toLocaleString("en-IN", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   });
      //   return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      // },
      selector: (row) => {
        const formatted = new Date(row.start).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },

      sortable: false,
    },
    {
      name: "End",
      key: "lastName",
      // selector: (row) => {
      //   return new Date(row.end).toLocaleString("en-IN", {
      //     year: "numeric",
      //     month: "2-digit",
      //     day: "2-digit",
      //     hour: "2-digit",
      //     minute: "2-digit",
      //     hour12: true,
      //   });
      // },
      selector: (row) => {
        const formatted = new Date(row.end).toLocaleString("en-US", {
          year: "numeric",
          month: "short", // or "long" for full month name
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
        return formatted.replace(/\b(am|pm)\b/g, (m) => m.toUpperCase());
      },
      sortable: false,
    },

    {
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <div className="d-flex gap-2">
          <img
            src={editIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              editEvent(row);
            }}
          />
          <img
            src={deleteIcon}
            title="Edit"
            alt="edit-icon"
            aria-hidden="true"
            className="cursor-pointer sbpc-icon-size cursor-pointer"
            onClick={() => {
              handleSingleEventDelete(row);
            }}
          />
          <ToggleSwitch
            name={`Status${row.memberId}`}
            id={`Status${row.memberId}`}
            checked={row.status === true}
            value={row.status === true ? 1 : 0}
            handleClick={(e) => handleSingleEventStatusUpdate(e, row)}
          />
        </div>
      ),
      sortable: false,
    },
  ];

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(
        Object.entries(Filter).filter(([_, v]) => v !== "")
      ),
    }).toString();

    setApiParams(`?${query}`);
  }, [Filter]);

  useEffect(() => {
    dispatch(eventsActions?.getPublicSingleEventList(apiParams));
  }, []);

  useEffect(() => {
    dispatch(eventsActions?.getPublicRecurrenceEventList(recurrenceApiParams));
  }, []);

  const editEvent = (row) => {
    // setEditRow(row);
    // const eventRow = { ...row };
    // // setEventID(row?._id);
    // eventRow["start"] = eventRow?.start ? new Date(row?.start) : "";
    // eventRow["end"] = eventRow?.end ? new Date(row?.end) : "";
    // eventRow["eventType"] = "single";
    // dispatch(eventsActions?.updateForm(eventRow));
    // Object.keys(expandedRows).forEach((key) => {
    //   expandedRows[key] = false;
    // });

    history?.navigate("PublicEvents/CreateOrEdit", {
      state: { publicEventRow: row },
    });
  };

  useEffect(() => {
    Swal.close();
  }, []);

  const handleSingleEventDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the event?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        debugger;
        dispatch(eventsActions?.deleteSingleEventPublic(row?._id))
          .then((result) => {
            if (result?.payload?.status === 1) {
              setIsPending(false);
              showToastNotification(result?.payload?.message, "success");
              const searchParams = `${apiParams}`;
              dispatch(eventsActions?.getPublicSingleEventList(searchParams));
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to create member", "error");
          });
        //close accordian
        Object.keys(expandedRows).forEach((key) => {
          expandedRows[key] = false;
        });
      },
    });
  };

  const handleRecurrenceEventDelete = (row) => {
    Popup({
      title: "Message",
      text: `Are you sure you want to delete the event?`,
      icon: "info",
      confirmButtonText: "YES",
      cancelButtonText: "NO",
      onConfirm: () => {
        // setEventID(row?._id);
        // dispatch(eventsActions?.deleteRecurrenceEvent(row?._id))
        dispatch(eventsActions?.deletePublicRecurrenceEvent(row?._id))
          .then((result) => {
            if (result?.payload?.status === 1) {
              setIsPending(false);
              showToastNotification(result?.payload?.message, "success");
              const searchParams = `${apiParams}`;
              dispatch(eventsActions?.getPublicSingleEventList(searchParams));
              dispatch(
                eventsActions?.getPublicRecurrenceEventList(searchParams)
              );
            } else {
              showToastNotification(result?.error?.message, "error");
            }
          })
          .catch((err) => {
            showToastNotification("Failed to create member", "error");
          });
      },
    });
  };

  const handleSingleEventStatusUpdate = (e, row) => {
    dispatch(eventsActions?.updateSingleEventStatusPublic(row?._id))
      .then((result) => {
        if (result?.payload?.status === 1) {
          setIsPending(false);
          showToastNotification(result?.payload?.message, "success");
          const searchParams = `${apiParams}`;
          dispatch(eventsActions?.getPublicSingleEventList(searchParams));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create member", "error");
      });
    //close accordian
    Object.keys(expandedRows).forEach((key) => {
      expandedRows[key] = false;
    });
  };

  const isSameDay = (start, end) => {
    return (
      start &&
      end &&
      start?.getFullYear() === end?.getFullYear() &&
      start?.getMonth() === end?.getMonth() &&
      start?.getDate() === end?.getDate()
    );
  };

  const handleRowPerPage = (page) => {
    let updatedParams = apiParams;
    updatedParams = updatedParams.replace(/(&limit=)\d+/, `$1${page}`);

    setApiParams(updatedParams);
    dispatch(eventsActions?.getPublicSingleEventList(updatedParams));
    setRowCountPerPage(page);
    setPageNo(1);
  };

  const handlePageChange = (page) => {
    debugger;
    let updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);

    updatedParams += ``;

    setApiParams(updatedParams);
    dispatch(eventsActions?.getPublicSingleEventList(updatedParams));
    setPageNo(page);
  };

  const handleRcurrenceRowPerPage = (page) => {
    setExpandedRows({}); //close the expand when change the pagination
    let updatedParams = recurrenceApiParams;
    updatedParams = updatedParams.replace(/(&limit=)\d+/, `$1${page}`);
    setRecurrenceApiParams(updatedParams);
    // const searchParams = `${apiParams}`;
    dispatch(eventsActions?.getPublicRecurrenceEventList(updatedParams));
    setRecurrenceRowCountPerPage(page);
    setRecurrencePageNo(1);
  };

  const handleRecurrencePageChange = (page) => {
    debugger;
    setExpandedRows({}); //close the expand when change the pagination
    let updatedParams = recurrenceApiParams.replace(
      /([?&])page=\d+/,
      `$1page=${page}`
    );
    setRecurrenceApiParams(updatedParams);
    // const searchParams = `${apiParams}`;
    dispatch(eventsActions?.getPublicRecurrenceEventList(updatedParams));
    setRecurrencePageNo(page);
  };

  const handleRowClick = (expanded, row) => {
    // track expanded state per row
    setExpandedRows((prev) => ({
      ...prev,
      [row._id]: expanded, // true or false
    }));

    // only fetch API when row is opening
    if (!expanded) return;
    // dispatch(eventsActions?.getRecurrenceDetailsByID(row?._id))
    dispatch(eventsActions?.getPublicRecurrenceDetailsByID(row?._id))
      .then((result) => {
        if (result?.payload?.status === 1) {
          debugger;
          const eventList =
            getPublicRecurrenceEventListResponse?.data?.events?.map((item) => {
              if (item?._id === row?._id) {
                return {
                  ...item,
                  children: result?.payload?.data?.events,
                };
              }
              return { ...item };
            });
          dispatch(eventsActions?.updatePublicRecurrenceEventList(eventList));
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification(err?.message, "error");
      });
  };

  const handleSearchChange = (e, select) => {
    let filtersearch = { ...Filter };

    if (select) {
      filtersearch[select] = e;
      setFilter(filtersearch);
      return;
    }
    const { name, value, type } = e?.target;
    if (value.startsWith(" ")) return;
    const filterParams = { ...Filter };
    filterParams[name] =
      type === "radio" ? (value === "true" ? true : false) : value;
    setFilter(filterParams);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    const searchParams = `${apiParams}`;
    dispatch(eventsActions?.getPublicSingleEventList(searchParams));
    dispatch(eventsActions?.getPublicRecurrenceEventList(searchParams));
    setExpandedRows(false);
  };

  const handleSearchFormReset = (e) => {
    debugger;
    e.preventDefault();
    setFilter({
      title: "",
      startDateTime: "",
      endDateTime: "",
      status: true,
    });
    const searchParams = `?page=${1}&limit=${10}&status=${true}`;
    dispatch(eventsActions?.getPublicSingleEventList(searchParams));
    dispatch(eventsActions?.getPublicRecurrenceEventList(searchParams));
  };

  const handleAddOrEditPage = () => {
    history?.navigate("PublicEvents/CreateOrEdit", {
      state: { publicEventRow: {} },
    });
  };

  if (loading) return <CustomLoader />;
  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h1 className="header-color">Public Events</h1>
        <div>
          <Button
            className="me-2"
            label="Create Event"
            status="secondary"
            onClick={() => {
              handleAddOrEditPage();
            }}
          />
        </div>
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          Search Event
        </h1>

        <form
          className="p-3 row"
          onSubmit={(e) => {
            handleSearchSubmit(e);
          }}
          onReset={(e) => {
            handleSearchFormReset(e);
          }}
        >
          <div className="col-md-4">
            <TextInput
              label="Title"
              placeholder="Title"
              name="title"
              id="title"
              handleChange={(e) => handleSearchChange(e)}
              value={Filter?.title}
            />
          </div>

          <div className="col-md-4">
            <DateInput
              name="start"
              id="start"
              handleChange={(e) => {
                handleSearchChange(e, "startDateTime");
              }}
              placeholder="Select Date"
              showTimeSelect={true}
              label={"Start Date & Time"}
              value={Filter?.startDateTime}
              isClearable={Filter?.startDateTime}
            />
          </div>

          <div className="col-md-4">
            <DateInput
              name="end"
              id="end"
              value={Filter?.endDateTime}
              handleChange={(e) => {
                handleSearchChange(e, "endDateTime");
              }}
              placeholder="Select Date"
              showTimeSelect={true}
              label={"End Date & Time"}
              isClearable={Filter?.endDateTime}
              minDate={Filter?.startDateTime}
              minTime={
                !isSameDay(
                  Filter?.startDateTime,
                  Filter?.startDateTime === ""
                    ? Filter?.startDateTime
                    : Filter?.endDateTime
                )
                  ? new Date(new Date().setHours(0, 0, 0, 0))
                  : Filter?.startDateTime
              }
              maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
            />
          </div>

          <div className="col-md-4">
            <RadioInput
              name="status"
              id="status"
              label="Status"
              options={ActiveStatus}
              handleChange={(e) => handleSearchChange(e)}
              selectedValue={Filter?.status}
              value={Filter?.status}
            />
          </div>

          <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
            <Button status="secondary" label="Search" type="submit" />
            <Button status="reset" label="Reset" type="reset" />
          </div>
        </form>
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color p-3 ">Single Events List</h1>
        <Table
          columns={columns}
          data={getPublicSingleEventListResponse?.data?.events}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={totalCount || 0}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color p-3 ">Recurrence Events List</h1>
        <CollapsibleTable
          columns={recurrenceTableColumn}
          data={getPublicRecurrenceEventListResponse?.data?.events}
          pagination
          onChangeRowsPerPage={handleRcurrenceRowPerPage}
          onChangePage={handleRecurrencePageChange}
          totalRowCount={recurrenceTotalCount || 10}
          currentPage={recurrencePageNo}
          paginationPerPage={recurrencerowCountPerPage}
          onRowClick={handleRowClick}
          nestedColumns={ChildrenColumn}
          expandableRowExpanded={true}
          expandedRows={expandedRows}
        />
      </div>
    </>
  );
}
export default PublicEvents;
